export default {"src":"/_next/static/media/back.e422dc7f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};